export const getFileExtension = (fileName: string | unknown) => {
  if (typeof fileName !== 'string') return undefined;
  const regExp = /\.([a-zA-Z]+)$/i;
  const ext = fileName.match(regExp);
  return ext?.[1];
};
